import template from './in-flat.jade';

export default angular
    .module('cian.addForm.inFlat', [])
    .directive('cianAfAboutObjectInFlat', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function () {
            this.checkboxes = [
                [
                    { text: 'Мебель в комнатах', model: 'hasFurniture' },
                    { text: 'Мебель на кухне', model: 'hasKitchenFurniture' },
                    { text: 'Холодильник', model: 'hasFridge' },
                    { text: 'Посудомойка', model: 'hasDishwasher' },
                    { text: 'Стиральная машина', model: 'hasWasher' },
                    { text: 'Интернет', model: 'hasInternet' },
                    { text: 'Телефон', model: 'hasPhone' },
                ], [
                    { text: 'Телевизор', model: 'hasTv' },
                    { text: 'Кондиционер', model: 'hasConditioner' },
                    { text: 'Ванна', model: 'hasBathtub' },
                    { text: 'Душевая кабина', model: 'hasShower' },
                    { text: 'Можно с детьми', model: 'childrenAllowed' },
                    { text: 'Можно с животными', model: 'petsAllowed' },
                ],
            ];
        }],
        controllerAs: 'inFlat',
        template,
    }))
    .name;
